import { Fragment, useState } from 'react';
import EditFeederModal from './EditFeederModal';
import Button from '../../atoms/Button';
import { GearIcon } from '../../atoms/Icons';
import PropTypes from 'prop-types';

function EditFeederModalTrigger({ feedLineName, feedLineIndex, feederIndex }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Fragment key={feedLineName + feedLineIndex}>
      <Button type="primary" content={<GearIcon />} variant="text" color="success" onClick={handleOpen} />
      {isOpen && (
        <EditFeederModal
          feedLineName={feedLineName}
          feedLineIndex={feedLineIndex}
          feederIndex={feederIndex}
          onClose={handleClose}
        />
      )}
    </Fragment>
  );
}
EditFeederModalTrigger.propTypes = {
  feedLineName: PropTypes.string,
  feedLineIndex: PropTypes.number,
  feederIndex: PropTypes.number,
};
export default EditFeederModalTrigger;
